import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col justify-start items-start gap-y-4 overflow-auto scrollbar pr-1" }
const _hoisted_2 = { class: "text-center w-full" }
const _hoisted_3 = { class: "text-center text-sm text-grey-darker" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex items-center mb-7 mt-3" }
const _hoisted_6 = { class: "ml-5" }
const _hoisted_7 = { class: "text-sm mt-3 text-grey-darker" }
const _hoisted_8 = { class: "text-sm mt-3 text-grey-darker" }
const _hoisted_9 = { class: "text-sm mt-3 text-grey-darker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar_container = _resolveComponent("avatar-container")!
  const _component_input_default = _resolveComponent("input-default")!
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_auth_container = _resolveComponent("auth-container")!

  return (_openBlock(), _createBlock(_component_auth_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$t("auth.registration")), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("auth.registration_text")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_avatar_container, {
              id: 'avatar',
              avatarStyle: { size: '9' },
              name: _ctx.emailParam ? _ctx.emailParam : ''
            }, null, 8, ["name"]),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.emailParam), 1)
          ]),
          _createVNode(_component_input_default, {
            class: "w-full mb-5",
            id: 'password',
            name: 'password',
            type: 'password',
            modelValue: _ctx.passwordObject.password,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwordObject.password) = $event)),
              _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeErrorMessage('email')))
            ],
            hasPasswordVisibilityToggle: true,
            onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.userRegister())),
            label: _ctx.$t('auth.password')
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_input_default, {
            class: "w-full",
            id: 'password_confirmation',
            metaId: 'email',
            name: 'password_confirmation',
            type: 'password',
            modelValue: _ctx.passwordObject.repeatPassword,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordObject.repeatPassword) = $event)),
              _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeErrorMessage('email')))
            ],
            hasPasswordVisibilityToggle: true,
            onEnter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.userRegister())),
            label: _ctx.$t('auth.repeat_password')
          }, null, 8, ["modelValue", "label"]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("settings.change_password_text1")), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("settings.change_password_text2")), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("settings.change_password_text3")), 1)
        ])
      ]),
      _createVNode(_component_custom_button, {
        id: 'register-button',
        class: "w-full mt-5",
        buttonStyle: _ctx.buttonStyle,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.userRegister()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("auth.register")), 1)
        ]),
        _: 1
      }, 8, ["buttonStyle"])
    ]),
    _: 1
  }))
}